import React, { Fragment, useState } from "react";
import { Row, Spinner } from "react-bootstrap";
import styled from "styled-components";
import CommonTable from "components/CommonTable";
import { CustomButton } from "components/CustomForm";
import useModal from "hooks/useModal";
import { deleteUnit, getUnits } from "network//apis/InformationApi";
import AddUnitModal from "./AddUnitModal";
import { useMutation, useQuery } from "react-query";
import { TbEditCircle } from "react-icons/tb";
import { TiDocumentDelete, TiTick } from "react-icons/ti";
import { ImCross } from 'react-icons/im';
import CommonPrompt from "components/DeletePrompt";
import { toast } from "react-toastify";

// const cols = [
//   { title: "حذف", width: "10%" },
//   { title: "ویرایش", width: "10%" },
//   { title: "مقدار پایه واحد سنجش", width: "30%" },
//   { title: "نوع واحد سنجش", width: "20%" },
//   { title: "نام واحد سنجش", width: "30%" },
//   { title: "ردیف", width: "5%" },
// ];

const cols = [
  'حذف',
  'ویرایش',
  'پیش فرض',
  'نسبت به واحد پیش فرض',
  'نام واحد سنجش',
  'ردیف'
];

const Holder = styled.div`
  background-color: white;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  width: 100%;
  margin: 0;
  padding: 0 2rem;

  div.header-button {
    display: flex;
    justify-content: end;
    width: 100%;
    margin-bottom: 1.5rem;
  }
  div.loading {
    min-height: 30rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3876e5;
  }
`;

const UnitsManagementTab = ({ currentTab = 'units-management' }) => {
  const { isOpen, handleOpenModal, handleCloseModal, data: editData } = useModal();
  const {
    isOpen: isDeleteModalOpen,
    handleOpenModal: handleOpenDeleteModal,
    handleCloseModal: handleCloseDeleteModel,
    data: deleteModalData,
  } = useModal();

  const {
    data: unitsData,
    refetch,
    isLoading,
  } = useQuery(["get-units"], () => getUnits(), {
    refetchOnWindowFocus: false,
    enabled: currentTab === 'units-management'
  });

  const deleteUnitMutation = useMutation(deleteUnit, {
    onSuccess: (res) => {
      console.log(res);
      if (res && res.status === 204) {
        toast(`با موفقیت حذف گردید`, {
          type: "success",
          position: "bottom-right",
        });
        refetch();
      }
    },
    onError: () => {
      toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
        type: "error",
        position: "bottom-right",
      });
    },
  });

  return (
    <Holder>
      {isLoading ? (
        <div className="loading">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <Fragment>
          <div className="header-button">
            <CustomButton onClick={() => handleOpenModal(null)}>
              افزودن واحد سنجش
            </CustomButton>
          </div>
          <CommonTable cols={cols}>
            {unitsData?.data?.map((unit, index) => (
              <tr key={unit?.unit_id}>
                <td>
                  <TiDocumentDelete onClick={() => {
                    handleOpenDeleteModal(unit);
                  }} />
                </td>
                <td>
                  <TbEditCircle onClick={() => {
                    handleOpenModal(unit);
                  }}
                  />
                </td>
                <td>{unit?.is_default ? <TiTick size={22} /> : <ImCross size={11} />}</td>
                <td>{unit?.conversion_to_default_unit}</td>
                <td>{unit?.name}</td>
                <td>{index + 1}</td>
              </tr>
            ))}
          </CommonTable>
        </Fragment>
      )}
      {isOpen && (
        <AddUnitModal
          isOpen
          onClose={handleCloseModal}
          size="md"
          data={editData}
          onCreateSuccess={refetch}
        />
      )}
      {isDeleteModalOpen && (
        <CommonPrompt
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModel}
          onActionTap={() => {
            handleCloseDeleteModel();
            deleteUnitMutation.mutate({ id: deleteModalData?.unit_id });
          }}
        />
      )}
    </Holder>
  );
};

export default UnitsManagementTab;
